<app-student-nav></app-student-nav>

<div class="careers-browse">
  <div class="browse-header">
    <h1 class="browse-title">Explore Careers</h1>
    <p class="browse-subtitle">Browse career paths shared by your counselors</p>
  </div>

  <!-- SEARCH + FILTERS -->
  <div class="cc-toolbar" role="search" aria-label="Search and filter careers">
    <div class="cd-filter-field cc-search-field">
      <label class="cd-filter-label" for="careers-search">Search careers</label>
      <input
        id="careers-search"
        class="cd-filter-input"
        type="text"
        placeholder="Search careers…"
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchInput($event)"
        (keydown.escape)="onSearchInput('')"
        aria-label="Search careers"
        autocomplete="off"
        [attr.data-testid]="'search-student-careers-input'"
      />
    </div>

    <mat-chip-listbox
      class="cc-chips"
      [(ngModel)]="activeFilter"
      hideSingleSelectionIndicator
      aria-label="Filter careers by status"
      data-testid="student-career-filter-listbox"
    >
      <mat-chip-option
        *ngFor="let f of filters"
        [value]="f"
        [selected]="activeFilter === f"
        (click)="activeFilter = f"
        [attr.data-testid]="'student-career-filter-' + f.toLowerCase()"
      >
        {{ f }}
      </mat-chip-option>
    </mat-chip-listbox>
  </div>

  <div class="careers-grid">
    @for (career of filteredCareers; track career) {
      <mat-card class="career-card" appearance="outlined" (click)="openPage(career)">
        <mat-card-content>
          <div class="career-card-emoji">{{ career.icon }}</div>

          <div class="career-card-info">
            <mat-chip-set>
              <mat-chip class="career-category-chip" disableRipple>
                {{ careerTypes().find((c) => c.id === career.career_type_id)?.name }}</mat-chip
              >
            </mat-chip-set>
            <div class="career-card-title">{{ career.name }}</div>
            <div class="career-card-tagline">{{ career.tagline }}</div>
          </div>

          <mat-divider class="career-divider"></mat-divider>

          <div class="career-card-footer">
            <span class="career-card-salary">{{ career.salary }}</span>
            <mat-icon class="career-card-arrow">arrow_forward</mat-icon>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
  @if (filteredCareers.length === 0) {
    <div class="browse-empty">No careers have been posted yet. Check back soon!</div>
  }
</div>
